import React from 'react';
import { StatusInfoWarning } from './StatusInfoWarning';
import { StatusInfoModifier } from './partials/StatusInfo';

/**
 * Styled Component for ReactGuard / ErrorBoundary
 * */
export function StatusInfoErrorBoundary() {
  return <StatusInfoWarning modifier={[StatusInfoModifier.CENTER, StatusInfoModifier.PADDING]} />;
}
